/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo} from '../../Helpers'

class GaraInCommessaComboFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {statoInCommessa: props.statoInCommessa}
        this.state = {
            fields: fields,
            dropdownLoading: false,
            dropdownList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboScelte = this.comboScelte.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.statoInCommessa !== this.state.fields.statoInCommessa)
        {
            let fields = this.state.fields;
            fields.statoInCommessa = nextProps.statoInCommessa;
            this.setState({fields},
                ()=>{
                    if ( this.state.fields.statoInCommessa !== undefined){
                        this.props.onChange(
                            this.state.fields.statoInCommessa,
                            this.getDDText(this.state.fields.statoInCommessa, this.state.dropdownList)
                        );
                    }
                });
        }
    }

    componentDidMount(){
        this.comboScelte();
    }

    getDDText(value, options){
        let selectedItem = options.find((it) => {
            return it.value === value;
        })
        return selectedItem ? selectedItem.text : '0';
    }

    comboScelte(){
        let items = [
            {statoInCommessa: '0', nome: 'Tutte le gare (con e senza commessa)'},
            {statoInCommessa: '-1', nome: 'Gare senza commessa'},
            {statoInCommessa: '1', nome: 'Gare con commessa'}
        ];
        this.setState(
            {
                dropdownLoading: false,
                error: null,
                dropdownList: arrayToCombo(items, "statoInCommessa", "nome", "statoInCommessa", false)
            },
            ()=>{
            if ( this.state.fields.statoInCommessa !== undefined){
                this.props.onChange(
                    this.state.fields.statoInCommessa,
                    this.getDDText(this.state.fields.statoInCommessa, this.state.dropdownList)
                );
            }
        })
    }

    onInputChange(a1, b1) {

        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields }, () => {
                this.props.onChange(this.state.fields.statoInCommessa, this.getDDText(value, b1.options));
            });

        }
    }

    render() {
        return (
            <div className="ui form">
                    <Form.Field className="fields">
                        <Form.Dropdown width={16} style={{width:"100%"}} name='statoInCommessa' disabled={this.props.abilitato === false} loading={this.state.dropdownLoading} search selection options={this.state.dropdownList} value={this.state.fields.statoInCommessa} onChange={this.onInputChange}/>
                    </Form.Field>
            </div>)
    }
}

GaraInCommessaComboFilter.PropTypes = {
    statoInCommessa: PropTypes.string.isRequired, // 0: tutte, 1: In commessa, -1: senza commessa
    abilitato: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

GaraInCommessaComboFilter.defaultProps = {
    statoInCommessa: '0',
    abilitato: false
};
export default GaraInCommessaComboFilter;



/** WEBPACK FOOTER **
 ** ./src/components/gare/GaraInCommessaComboFilter.js
 **/